import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaRegistro: '1900-01-01',
    fechaEncuesta: '1900-01-01',
    encuestaUsuarioTipo: '',
    usuarioReferido: '',
    referencia: '',
    observaciones: '',
    calificacion: 0,

    items: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, encuestaUsuarioId) {
        state.id = encuestaUsuarioId || 0;
        state.fechaRegistro = '1900-01-01';
        state.fechaEncuesta = '1900-01-01';
        state.encuestaUsuarioTipo = '';
        state.usuarioReferido = '';
        state.calificacion = 0;
        state.referencia = '';
        state.observaciones = '';

        state.items = [];
    },
    'SET_ENCUESTA' (state, encuestaUsuario) {
        state.fechaRegistro = moment(encuestaUsuario.fechaRegistro).format('YYYY-MM-DD');
        state.fechaEncuesta = moment(encuestaUsuario.fechaEncuesta).format('YYYY-MM-DD'),
        state.encuestaUsuarioTipo = encuestaUsuario.encuestaUsuarioTipo;
        state.usuarioReferido = encuestaUsuario.usuarioReferido;
        state.calificacion = encuestaUsuario.calificacion;
        state.referencia = encuestaUsuario.referencia;
        state.observaciones = encuestaUsuario.observaciones.trim();

        state.items = encuestaUsuario.items;
    },
};

const getters = {
    getField,
};

const actions = {
    getEncuestaUsuario ( { commit }, encuestaUsuarioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', encuestaUsuarioId);

            if (encuestaUsuarioId != 0) {
                /* Recuperamos los datos de la encuesta */
                apiAxios.get(`encuestas-usuarios/${encuestaUsuarioId}`)
                    .then(res => {
                        commit('SET_ENCUESTA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                resolve();
            }   
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}